<div class="metric-settings-ddl">
  <div class="title-save-and-go-to">
    <div class="title-save">
      <h2 class="ddl-title">Other Reports Link</h2>
      <button
        *ngIf="hasChangesToSave"
        mat-raised-button
        class="save-btn green-btn"
        (click)="saveOtherReportsUrl.emit()"
        [disabled]="pending || error"
      >
        SAVE
      </button>
      <p *ngIf="savedSuccessfully" class="green-text fields-saved-text">
        Saved!
      </p>
      <p *ngIf="error" class="general-error name-error">{{ error }}</p>
    </div>
  </div>
  <p class="description">
    Enter a URL. Users will be redirected to this link from the Other Reports
    button, which can be found in Metric Zoom.
  </p>
  <div class="link-div">
    <input
      type="text"
      title="Other Report Link"
      class="form-control link-input"
      placeholder="Enter a URL."
      [ngModel]="metric?.otherReportsUrl"
      [disabled]="isStarter"
      (ngModelChange)="otherReportsUrlChanged.emit($event)"
    />
    <button
      mat-raised-button
      class="test-link-btn green-btn"
      [disabled]="error || (metric && !metric.otherReportsUrl)"
      (click)="testLink()"
    >
      <img
        [src]="'../../assets/images/deep_dive_icon_white.svg'"
        class="data-wall-img"
      />
      TEST LINK
    </button>
  </div>
</div>
